<template>
  <div class="declare-project-container">
    <!-- 项目信息 -->
    <InfoContainer
      :infoTitle="infoConConfig['infoTitle']"
      :contentConfig="infoConConfig['infoContent']"
      class="comment-container"
    >
      <template #projectInfo>
        <avue-form
          ref="addFormRef"
          v-model="formData"
          :option="formConfig"
        >
          <template #number>
            <span>{{ formData.number }}</span>
          </template>
          <template #contactPersonList>
            <div class="person-container">
              <el-button type="primary" size="mini" @click="createNewConact">新增联系人</el-button>

              <div
                v-if="personList.length > 0"
                v-for="(item, index) in personList"
                :key="index"
                class="person-con"
              >
                <div class="person-item flex-con" >
                  <span class="person-item-title">{{ `${item.name}/${item.phone}/${item.job}` }}</span>
                  <div class="button-right">
                    <el-button type="text" @click="editPerson(index)">编辑</el-button><el-divider direction="vertical"></el-divider>
                    <el-button type="text" style="color: #f56c6c;" @click="deletePerson(index)">删除</el-button>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </avue-form>
      </template>
    </InfoContainer>

    <!-- 意见建议 -->
    <InfoContainer
      :infoTitle="adviceConfig['infoTitle']"
      :contentConfig="adviceConfig['infoContent']"
      class="comment-container"
    >
      <template #content>
        <avue-form
          ref="adviceFormRef"
          v-model="adviceData"
          :option="adviceFormConfig"
        ></avue-form>
      </template>
    </InfoContainer>

    <!-- 附件上传 -->
    <InfoContainer
      v-if="projectId!=''"
      :infoTitle="uploadConfig['infoTitle']"
      :contentConfig="uploadConfig['infoContent']"
      :uploadButton="false"
      @uploadClick="chooseFile"
    >
      <template #content>
        <Accessory
          element-loading-text="加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(153, 153, 153, 0.8)"        
          :projectid="projectId"
          :dynamicId="projectId"
          fileMenuUrlname="数字化招商平台"
          idname="项目申报"
          :upload="true"
        />
      </template>
    </InfoContainer>

    <div class="bottom-submit-con">
      <el-button type="primary" @click="saveData(false)">保存</el-button>
      <el-button type="primary" plain @click="saveData(true)">提交</el-button>
    </div> 

    <el-dialog
      title="新增联系人"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <avue-form
        ref="addPersonRef"
        v-model="personFormData"
        :option="addPersonFormConfig"
      >
      </avue-form>
      <div class="submit-con">
        <el-button
          type="primary"
          size="mini"
          @click="dialogVisible = false"
        >取消</el-button>
        <el-button
          type="primary"
          size="mini"
          plain
          @click="addPerson()"
        >确定</el-button>        
      </div>
    </el-dialog>
  </div>
</template>
<script>
import InfoContainer from "@/components/infoContainer/zsInfoContainer";
import Accessory from "@/components/accessoriesother/accessoryFactor";
import { addProject, getProjectDetail, getVirtualId } from "@/api/zs/zs"
import { declareProjectConfig, addPersonFormConfig, adviceConfig } from "./config.js";
import workFlow from "@/mixins/workFlow";
export default {
  name: 'DeclareProject',
  components: {
    Accessory,
    InfoContainer
  },
  mixins: [workFlow],
  data() {
    return {
      processKey: 'process_zs_project',
      flowableId: '',
      processDefinedId: '',
      dialogVisible: false,
      personFormData: {
        index: '',
        name: '',
        phone: '',
        job: ''
      },
      formData: {
        projectType: ''
      },
      adviceData: {},
      personList: [],
      projectId: '',
      formConfig: declareProjectConfig(this.changeColumn),
      adviceFormConfig: adviceConfig(),
      addPersonFormConfig: addPersonFormConfig(),
      infoConConfig: {
        infoTitle: "项目信息",
        infoContent: [
          {
            title: "",
            prop: "projectInfo",
          },
        ],
      },
      adviceConfig: {
        infoTitle: "意见建议",
        infoContent: [
          {
            title: "",
            prop: "content",
          },
        ],
      },
      uploadConfig: {
        infoTitle: "附件上传",
        infoContent: [
          {
            title: "",
            prop: "content",
          },
        ],
      }

    }
  },
  async mounted() {
    // 查询流程实例ID
    this.processDefinedId = await this.userQueryProcessDefinedId(this.processKey)
    // 创建ID
    if(this.$route.params.id == '-1') {
      this.createId()
    } else {
      this.projectId = this.$route.params.id
      this.queryProjectDetail()
    }
  },
  methods: {
    async queryProjectDetail() {
      const params = { id: this.projectId }
      const res = await getProjectDetail(params)
      if(res.data.code == 200) {
        const data = res.data.data
        this.formData = {
          number: data.number,
          projectName: data.projectName,
          projectType: `${data.projectType}`,
          talentType: `${data.talentType}`,
          investScale: data.investScale,
          investor: data.investor,
          projectLanding: `${data.projectLanding}`,
          contactPersonList: data.contactPersonList,
          projectOverview: data.projectOverview,
          projectDemands: data.projectDemands,
          contactSituation: data.contactSituation,
          additionalContent: data.additionalContent
        }
        this.adviceData.advice = data.advice
        this.personList = data.contactPersonList

        /**
         * 判断是否已发起流程
         * 若已经发起流程，提交流程流转下一步
         * 未发起流程， 提交发起流程
         * */ 
        if(data.flowableId && data.flowableId != '') {
          this.flowableId = data.flowableId
          // 查询流程详情
          await this.queryFlowData(this.flowableId)
        }
      }
    },

    changeColumn(value) {
      const self = this
      this.$nextTick(() => {
        self.formConfig.column.forEach(item => {
          if(item.prop == "talentType") {
            item.display = value == 4?true:false
          }
          if(item.prop == "investScale") {
            item.display = value == 4?false: true
          }
        })
      })
    },

    async createId() {
      const res = await getVirtualId()
      if(res.data.code === 200) {
        this.projectId = res.data.data
      }
    },

    createNewConact() {
      if(this.$refs.addPersonRef) {
        this.$refs.addPersonRef.resetForm()
      }
      this.dialogVisible = true
    },
    editPerson(index) {
      this.personFormData.index = index
      this.personFormData = this.personList[index]
      this.dialogVisible = true
    },
    // 删除personList中序号为index的元素
    deletePerson(index) {
      this.personList.splice(index, 1)
      this.formData.contactPersonList = JSON.parse(JSON.stringify(this.personList))
    },

    // 新增或修改联系人
    addPerson() {
      const self = this
      this.$refs.addPersonRef.validate((valid, done) => {
        if(valid) {
          if( !isNaN(Number(self.personFormData.index)) && self.personFormData.index !== '') {
            self.personList[self.personFormData.index].name = self.personFormData.name
            self.personList[self.personFormData.index].phone = self.personFormData.phone
            self.personList[self.personFormData.index].job = self.personFormData.job
            self.formData.contactPersonList = self.personList
            self.personFormData.index = ''
          } else {
            self.personList.push(JSON.parse(JSON.stringify(self.personFormData)))
            self.formData.contactPersonList = JSON.parse(JSON.stringify(self.personList))
          }
          this.dialogVisible = false
          done()
        }else {
          done()
        }
      })
    },

    /**
     * start为true表示触发提交按钮，发起流程或转交下一步
    */
    saveData(start) {
      const self = this
      this.$refs.addFormRef.validate(async (valid, done) => {
        if(valid) {
          let processInsId = ''
          const params = {
            ...self.formData,
            ...self.adviceData,
            id: self.projectId,
          }

          if(self.flowableId == '' && start) {
            // 未发起流程
            const redirectInfo = {
              url: '/zsProject/projectDetail',
              id: self.projectId
            }
            const processParams = {
              detailFormUrl: JSON.stringify(redirectInfo),
              processId: self.processDefinedId,
              comment: '',
              attachmentList: '',
              processInstanceName: `${self.formData.projectName}`
            }
            processInsId = await self.startWorkFlowProcess(processParams)
            params.flowableId = processInsId
          }
          if(self.flowableId !== '' && start){
            // 已发起流程，保存流程并转交下一步
            params.flowableId = self.flowableId
            let taskId = self.processDetail.process.taskId
            let processInsId = self.processDetail.process.processInstanceId
            await self.taskFlowNext(
              taskId,
              processInsId,
              self.workFlowData.attchmentList?self.workFlowData.attchmentList:[],
              self.workFlowData.opinionContent?self.workFlowData.opinionContent:'',
              {}
            )
          }
          const res = await addProject(params)
          if(res.data.code == 200) {
            self.$message.success('保存成功')
            // 若已发起流程, 跳转流程详情页
            if(self.flowableId !== '') {
              self.$router.push({path: `/zsProject/projectDetail/${self.projectId}`})
            }else {
              // 跳转详情
            }
            done()
          }
        }else {
          self.$message.warning('请填写必填项后提交')
          done()
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.declare-project-container{
  .flex-con {
    display: flex;
    justify-content: space-between;
    align-items: center; 
  }
  /deep/ .info-container-temp .box-card .detail-one{
    padding: 10px 50px !important;
  }
  /deep/ .avue-form__menu{
    display: none; 
  }
  /deep/.el-dialog {
    border-radius: 8px;
  }  
  /deep/ .el-dialog__header {
    border-radius: 5px 5px 0px 0px;
    background-color: rgb(245, 245, 245);
    color: #333;
    border-bottom: 1px solid #e4e4e4e4;
  }
  /deep/ .el-dialog__body {
    padding: 20px 20px 20px !important;
  }
  .submit-con {
    text-align: right;
    padding-top: 15px;
    border-top: 1px solid #e4e4e4e4;
  }

  .bottom-submit-con{
    width: 100%;
    text-align: center;
    padding-bottom: 20px;
    button{
      width: 150px;
    }
  }
}
</style>